import request from '@/utils/request'

export function getAgendaList(data,domin){
  // 待办列表查询
  return request({
    url: `/api/openApi/backlog/queryBacklog`,
    method: 'POST',
    data,
    baseURL:domin
  })
}

export function  getUnreadMessage(params,domin){
  // 查询站内信消息列表
  return request({
    url: `/api/admin/mc/message/list`,
    method: 'GET',
    params,
    baseURL:domin
  })
}




// WEBPACK FOOTER //
// ./src/api/headmenu.js